export default "__VITE_ASSET__TL7RYI3c__"